// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__358iF","upload":"Small_upload__3dFIr","imageWrap":"Small_imageWrap__2kC0u","removeBtn":"Small_removeBtn__nyITB"};